import React from "react";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../../utils/Utils";
import CheckBoxTable from "./CheckBoxTable";


class DiagnosiEseguitaStreptococcus extends React.Component {

    state = {
        diagnosiStreptococcus: {
            liquorStrepto: this.props.statePadre && ( this.props.statePadre.liquorStrepto || this.props.statePadre.liquorStrepto == false ) ? this.props.statePadre.liquorStrepto : false,
            sangueStrepto: this.props.statePadre && ( this.props.statePadre.sangueStrepto || this.props.statePadre.sangueStrepto == false ) ? this.props.statePadre.sangueStrepto : false,
            liquidoPleuricoStrepto: this.props.statePadre && ( this.props.statePadre.liquidoPleuricoStrepto || this.props.statePadre.liquidoPleuricoStrepto == false ) ? this.props.statePadre.liquidoPleuricoStrepto : false,
            liquidoPeritonealeStrepto: this.props.statePadre && ( this.props.statePadre.liquidoPeritonealeStrepto || this.props.statePadre.liquidoPeritonealeStrepto == false ) ? this.props.statePadre.liquidoPeritonealeStrepto : false,
            liquidoPericardioStrepto: this.props.statePadre && ( this.props.statePadre.liquidoPericardioStrepto || this.props.statePadre.liquidoPericardioStrepto == false ) ? this.props.statePadre.liquidoPericardioStrepto : false,
            liquidoSinovialeStrepto: this.props.statePadre && ( this.props.statePadre.liquidoSinovialeStrepto || this.props.statePadre.liquidoSinovialeStrepto == false ) ? this.props.statePadre.liquidoSinovialeStrepto : false,
            placentaStrepto: this.props.statePadre && ( this.props.statePadre.placentaStrepto || this.props.statePadre.placentaStrepto == false ) ? this.props.statePadre.placentaStrepto : false,
            materialeStrepto: this.props.statePadre && ( this.props.statePadre.materialeStrepto || this.props.statePadre.materialeStrepto == false ) ? this.props.statePadre.materialeStrepto : false,

            colturaStreptoLiquor1: this.props.statePadre && ( this.props.statePadre.colturaStreptoLiquor1 || this.props.statePadre.colturaStreptoLiquor1 == false ) ? this.props.statePadre.colturaStreptoLiquor1 : false,
            colturaStreptoSangue2: this.props.statePadre && ( this.props.statePadre.colturaStreptoSangue2 || this.props.statePadre.colturaStreptoSangue2 == false ) ? this.props.statePadre.colturaStreptoSangue2 : false,
            colturaStreptoPleurico3: this.props.statePadre && ( this.props.statePadre.colturaStreptoPleurico3 || this.props.statePadre.colturaStreptoPleurico3 == false ) ? this.props.statePadre.colturaStreptoPleurico3 : false,
            colturaStreptoPeritoneale4: this.props.statePadre && ( this.props.statePadre.colturaStreptoPeritoneale4 || this.props.statePadre.colturaStreptoPeritoneale4 == false ) ? this.props.statePadre.colturaStreptoPeritoneale4 : false,
            colturaStreptoPericardio5: this.props.statePadre && ( this.props.statePadre.colturaStreptoPericardio5 || this.props.statePadre.colturaStreptoPericardio5 == false ) ? this.props.statePadre.colturaStreptoPericardio5 : false,
            colturaStreptoSinoviale6: this.props.statePadre && ( this.props.statePadre.colturaStreptoSinoviale6 || this.props.statePadre.colturaStreptoSinoviale6 == false ) ? this.props.statePadre.colturaStreptoSinoviale6 : false,
            colturaStreptoPlacenta7: this.props.statePadre && ( this.props.statePadre.colturaStreptoPlacenta7 || this.props.statePadre.colturaStreptoPlacenta7 == false ) ? this.props.statePadre.colturaStreptoPlacenta7 : false,
            colturaStreptoMateriale8: this.props.statePadre && ( this.props.statePadre.colturaStreptoMateriale8 || this.props.statePadre.colturaStreptoMateriale8 == false ) ? this.props.statePadre.colturaStreptoMateriale8 : false,

            ricercaStreptoLiquor1: this.props.statePadre && ( this.props.statePadre.ricercaStreptoLiquor1 || this.props.statePadre.ricercaStreptoLiquor1 == false ) ? this.props.statePadre.ricercaStreptoLiquor1 : false,
            ricercaStreptoPleurico3: this.props.statePadre && ( this.props.statePadre.ricercaStreptoPleurico3 || this.props.statePadre.ricercaStreptoPleurico3 == false ) ? this.props.statePadre.ricercaStreptoPleurico3 : false,
            ricercaStreptoPeritoneale4: this.props.statePadre && ( this.props.statePadre.ricercaStreptoPeritoneale4 || this.props.statePadre.ricercaStreptoPeritoneale4 == false ) ? this.props.statePadre.ricercaStreptoPeritoneale4 : false,
            ricercaStreptoPericardio5: this.props.statePadre && ( this.props.statePadre.ricercaStreptoPericardio5 || this.props.statePadre.ricercaStreptoPericardio5 == false ) ? this.props.statePadre.ricercaStreptoPericardio5 : false,
            ricercaStreptoSinoviale6: this.props.statePadre && ( this.props.statePadre.ricercaStreptoSinoviale6 || this.props.statePadre.ricercaStreptoSinoviale6 == false ) ? this.props.statePadre.ricercaStreptoSinoviale6 : false,
            ricercaStreptoPlacenta7: this.props.statePadre && ( this.props.statePadre.ricercaStreptoPlacenta7 || this.props.statePadre.ricercaStreptoPlacenta7 == false ) ? this.props.statePadre.ricercaStreptoPlacenta7 : false,


            pcrStreptoLiquor1: this.props.statePadre && ( this.props.statePadre.pcrStreptoLiquor1 || this.props.statePadre.pcrStreptoLiquor1 == false ) ? this.props.statePadre.pcrStreptoLiquor1 : false,
            pcrStreptoSangue2: this.props.statePadre && ( this.props.statePadre.pcrStreptoSangue2 || this.props.statePadre.pcrStreptoSangue2 == false ) ? this.props.statePadre.pcrStreptoSangue2 : false,
            pcrStreptoPleurico3: this.props.statePadre && ( this.props.statePadre.pcrStreptoPleurico3 || this.props.statePadre.pcrStreptoPleurico3 == false ) ? this.props.statePadre.pcrStreptoPleurico3 : false,
            pcrStreptoPeritoneale4: this.props.statePadre && ( this.props.statePadre.pcrStreptoPeritoneale4 || this.props.statePadre.pcrStreptoPeritoneale4 == false ) ? this.props.statePadre.pcrStreptoPeritoneale4 : false,
            pcrStreptoPericardio5: this.props.statePadre && ( this.props.statePadre.pcrStreptoPericardio5 || this.props.statePadre.pcrStreptoPericardio5 == false ) ? this.props.statePadre.pcrStreptoPericardio5 : false,
            pcrStreptoSinoviale6: this.props.statePadre && ( this.props.statePadre.pcrStreptoSinoviale6 || this.props.statePadre.pcrStreptoSinoviale6 == false ) ? this.props.statePadre.pcrStreptoSinoviale6 : false,
            pcrStreptoPlacenta7: this.props.statePadre && ( this.props.statePadre.pcrStreptoPlacenta7 || this.props.statePadre.pcrStreptoPlacenta7 == false ) ? this.props.statePadre.pcrStreptoPlacenta7 : false,
            pcrStreptoMateriale8: this.props.statePadre && ( this.props.statePadre.pcrStreptoMateriale8 || this.props.statePadre.pcrStreptoMateriale8 == false ) ? this.props.statePadre.pcrStreptoMateriale8 : false,
            corretto: []
        },
        malattiaBatterica: "",
        id: "",
        rowList: [],
        row: 0
    }

    constructor(props) {
        super(props)

        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.setStateGenerico = this.setStateGenerico.bind(this)
    }

    componentDidMount() {

        this.setState({malattiaBatterica: this.props.malattiaBatterica})
        let oggetto = this.createOggettoBE()
        let diagnosiStreptococcus = this.state.diagnosiStreptococcus
        this.props.setDiagnosiStreptococcus(this.state.diagnosiStreptococcus, oggetto)

        let statePadre = JSON.parse(JSON.stringify(this.props.statePadre))
        delete statePadre["corretto"];

        if(Utils.isEmpty(statePadre)) {
            if (this.props.malattiaBatterica !== "malattiaBatterica2") {
                diagnosiStreptococcus.corretto = true
                this.setState({
                    malattiaBatterica: this.props.malattiaBatterica,
                    diagnosiStreptococcus: diagnosiStreptococcus
                })
            } else if (this.props.malattiaBatterica === "malattiaBatterica2") {
                if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.diagnosiStreptococcus) {
                    diagnosiStreptococcus = this.state.diagnosiStreptococcus
                    let diagnosiStreptococcusProps = this.props.segnalazioneCopia.schedaSpeciale.diagnosiStreptococcus

                    for (let key in diagnosiStreptococcus) {
                        if (diagnosiStreptococcus.hasOwnProperty(key) === diagnosiStreptococcusProps.hasOwnProperty(key)) {
                            diagnosiStreptococcus[key] = diagnosiStreptococcusProps[key]
                        } else {
                            diagnosiStreptococcus[key] = false
                        }
                    }

                    this.setState({diagnosiStreptococcus: diagnosiStreptococcus});

                }
            }
        }
        oggetto = this.createOggettoBE()
        this.props.setDiagnosiStreptococcus(this.state.diagnosiStreptococcus, oggetto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattiaBatterica != this.props.malattiaBatterica) {
            if (this.props.malattiaBatterica !== "malattiaBatterica2") {
                let diagnosiStreptococcus = this.state.diagnosiStreptococcus

                for (let key in diagnosiStreptococcus) {
                    diagnosiStreptococcus[key] = false
                }

                this.setState({
                    diagnosiStreptococcus: diagnosiStreptococcus,
                    malattiaBatterica: this.props.malattiaBatterica
                })
                // this.controlloDati()
                let oggetto = this.createOggettoBE()
                this.props.setDiagnosiStreptococcus(this.state.diagnosiStreptococcus, oggetto)
            } else {
                this.setState({malattiaBatterica: this.props.malattiaBatterica})
                // this.controlloDati()
                let oggetto = this.createOggettoBE()
                this.props.setDiagnosiStreptococcus(this.state.diagnosiStreptococcus, oggetto)
            }
        }
    }

    createOggettoBE() {
        let diagnosiStreptococcus = JSON.parse(JSON.stringify(this.state.diagnosiStreptococcus))
        let diagnosiStreptococcusBe = Utils.removeEmptyValueFromObject(diagnosiStreptococcus)
        return Utils.removeFieldFromObject(diagnosiStreptococcusBe, "corretto")

    }

    controlloDati() {
        let diagnosiStreptococcus = this.state.diagnosiStreptococcus

        if (!(
            diagnosiStreptococcus.liquorStrepto && (diagnosiStreptococcus.colturaStreptoLiquor1 || diagnosiStreptococcus.ricercaStreptoLiquor1 || diagnosiStreptococcus.pcrStreptoLiquor1) ||
            diagnosiStreptococcus.sangueStrepto && (diagnosiStreptococcus.colturaStreptoSangue2 || diagnosiStreptococcus.pcrStreptoSangue2) ||
            diagnosiStreptococcus.liquidoPleuricoStrepto && (diagnosiStreptococcus.colturaStreptoPleurico3 || diagnosiStreptococcus.pcrStreptoPleurico3 || diagnosiStreptococcus.ricercaStreptoPleurico3) ||
            diagnosiStreptococcus.liquidoPeritonealeStrepto && (diagnosiStreptococcus.colturaStreptoPeritoneale4 || diagnosiStreptococcus.pcrStreptoPeritoneale4 || diagnosiStreptococcus.ricercaStreptoPeritoneale4) ||
            diagnosiStreptococcus.liquidoPericardioStrepto && (diagnosiStreptococcus.colturaStreptoPericardio5 || diagnosiStreptococcus.pcrStreptoPericardio5 || diagnosiStreptococcus.ricercaStreptoPericardio5) ||
            diagnosiStreptococcus.liquidoSinovialeStrepto && (diagnosiStreptococcus.colturaStreptoSinoviale6 || diagnosiStreptococcus.pcrStreptoSinoviale6 || diagnosiStreptococcus.ricercaStreptoSinoviale6) ||
            diagnosiStreptococcus.placentaStrepto && (diagnosiStreptococcus.colturaStreptoPlacenta7 || diagnosiStreptococcus.pcrStreptoPlacenta7 || diagnosiStreptococcus.ricercaStreptoPlacenta7) ||
            diagnosiStreptococcus.materialeStrepto && (diagnosiStreptococcus.colturaStreptoMateriale8 || diagnosiStreptococcus.pcrStreptoMateriale8))) {
            diagnosiStreptococcus.corretto[0] = "Campo \"Pneumococco (S. Pneumoniae)\" mancante o errato";
        }

        this.setState({diagnosiStreptococcus: diagnosiStreptococcus})

    }

    setStateGenerico(object) {
        this.setState(object)
        // this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDiagnosiStreptococcus(this.state.diagnosiStreptococcus, oggetto)
    }

    render() {


        let disabled = this.props.malattiaBatterica && this.props.malattiaBatterica != "malattiaBatterica2" ? true : false

        let rows_Strepto = [
            {
                check1Liquor1_Strepto1: {
                    id: "liquorStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.1",
                    radio: false,
                    field: "liquorStrepto",
                    numeroCol: 1,
                    row: 1
                },
                check2Liquor2_Strepto2: {
                    id: "colturaStreptoLiquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoLiquor",
                    numeroCol: 2,
                    row: 1
                },
                check3Liquor3_Strepto3: {
                    id: "ricercaStreptoLiquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricercaStreptoLiquor",
                    numeroCol: 3,
                    row: 1
                },
                check4Liquor4_Strepto4: {
                    id: "pcrStreptoLiquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoLiquor",
                    numeroCol: 4,
                    row: 1
                },
            },
            {
                check1Sangue1_Strepto1: {
                    id: "sangueStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.2",
                    radio: false,
                    field: "sangueStrepto",
                    numeroCol: 1,
                    row: 2
                },
                check2Sangue2_Strepto2: {
                    id: "colturaStreptoSangue2",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoSangue",
                    numeroCol: 2,
                    row: 2
                },
                check3Sangue3_Strepto3: {
                    id: "pcrStreptoSangue2",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoSangue",
                    numeroCol: 4,
                    row: 2
                }
            },
            {
                check1Pleurico1_Strepto1: {
                    id: "liquidoPleuricoStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.3",
                    radio: false,
                    field: "liquidoPleuricoStrepto",
                    numeroCol: 1,
                    row: 3
                },
                check2Pleurico2_Strepto2: {
                    id: "colturaStreptoPleurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoPleurico",
                    numeroCol: 2,
                    row: 3
                },
                check3Pleurico3_Strepto3: {
                    id: "ricercaStreptoPleurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricercaStreptoPleurico",
                    numeroCol: 3,
                    row: 3
                },
                check4Pleurico4_Strepto4: {
                    id: "pcrStreptoPleurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoPleurico",
                    numeroCol: 4,
                    row: 3
                }

            },
            {
                check1Peritoneale1_Strepto1: {
                    id: "liquidoPeritonealeStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.4",
                    radio: false,
                    field: "liquidoPeritonealeStrepto",
                    numeroCol: 1,
                    row: 4
                },
                check2Peritoneale2_Strepto2: {
                    id: "colturaStreptoPeritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoPeritoneale",
                    numeroCol: 2,
                    row: 4
                },
                check3Peritoneale3_Strepto3: {
                    id: "ricercaStreptoPeritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricercaStreptoPeritoneale",
                    numeroCol: 3,
                    row: 4
                },
                check4Peritoneale4_Strepto4: {
                    id: "pcrStreptoPeritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoPeritoneale",
                    numeroCol: 4,
                    row: 4
                }
            },
            {
                check1Pericardio1_Strepto1: {
                    id: "liquidoPericardioStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.5",
                    radio: false,
                    field: "liquidoPericardioStrepto",
                    numeroCol: 1,
                    row: 5
                },
                check2Pericardio2_Strepto2: {
                    id: "colturaStreptoPericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoPericardio",
                    numeroCol: 2,
                    row: 5
                },
                check3Pericardio3_Strepto3: {
                    id: "ricercaStreptoPericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricercaStreptoPericardio",
                    numeroCol: 3,
                    row: 5
                },
                check4Pericardio4_Strepto4: {
                    id: "pcrStreptoPericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoPericardio",
                    numeroCol: 4,
                    row: 5
                }
            },
            {
                check1Sinoviale1_Strepto1: {
                    id: "liquidoSinovialeStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.8",
                    radio: false,
                    field: "liquidoSinovialeStrepto",
                    numeroCol: 1,
                    row: 6
                },
                check2Sinoviale2_Strepto2: {
                    id: "colturaStreptoSinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoSinoviale",
                    numeroCol: 2,
                    row: 6
                },
                check3Sinoviale3_Strepto3: {
                    id: "ricercaStreptoSinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricercaStreptoSinoviale",
                    numeroCol: 3,
                    row: 6
                },
                check4Sinoviale4_Strepto4: {
                    id: "pcrStreptoSinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoSinoviale",
                    numeroCol: 4,
                    row: 6
                }
            },
            {
                check1Placenta1_Strepto1: {
                    id: "placentaStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.6",
                    radio: false,
                    field: "placentaStrepto",
                    numeroCol: 1,
                    row: 7
                },
                check2Placenta2_Strepto2: {
                    id: "colturaStreptoPlacenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoPlacenta",
                    numeroCol: 2,
                    row: 7
                },
                check3Placenta3_Strepto3: {
                    id: "ricercaStreptoPlacenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.11",
                    radio: true,
                    field: "ricercaStreptoPlacenta",
                    numeroCol: 3,
                    row: 7
                },
                check4Placenta4_Strepto4: {
                    id: "pcrStreptoPlacenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoPlacenta",
                    numeroCol: 4,
                    row: 7
                }
            },
            {
                check1Materiale1_Strepto1: {
                    id: "materialeStrepto",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.9",
                    radio: false,
                    field: "materialeStrepto",
                    numeroCol: 1,
                    row: 8
                },
                check2Materiale2_Strepto2: {
                    id: "colturaStreptoMateriale8",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaStreptoMateriale",
                    numeroCol: 2,
                    row: 8
                },
                check3Materiale3_Strepto3: {
                    id: "pcrStreptoMateriale8",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrStreptoMateriale",
                    numeroCol: 4,
                    row: 8
                }
            }
        ]

        return (
            <div>
                <fieldset disabled={this.props.malattiaBatterica !== "malattiaBatterica2"}>
                    <CheckBoxTable tipoMalattiaBattareica={"malattiaBatterica2"}
                                   intestazione={"SchedaFlussoSpeciale.MIB.DiagnosiEseguita.titolo2"}
                                   stato={this.state.diagnosiStreptococcus}
                                   disabled={disabled} rows={rows_Strepto} rowList={this.state.rowList}
                                   setStatePadre={this.setStateGenerico} id={this.state.id} row={this.state.row}/>
                </fieldset>
            </div>

        )
    }

}

export default withTranslation('common')(DiagnosiEseguitaStreptococcus)
